window.dataTableAjax = (function() {

    var compileCache = {};
    var drawCount = 0;
    var sortCols = $.map($('th[data-name]'), function(value, i) {
        return $(value).attr('data-name');
    });

    function renderTemplate(data, element) {
        if(compileCache[element]) {
            return compileCache[element](data);
        } else {
            var theTemplateScript = $(element).html();
            var theTemplate = Handlebars.compile(theTemplateScript);

            compileCache[element] = theTemplate;
            return theTemplate(data);
        }
    }

    // Search
    function advancedSearch(element) {
        var url = $(element).serialize();
        return $.deparam(url);
    }

    function getSortName(name) {
        var direction = 'asc';

        if (name && name.substr(0, 1) == '-') {
            direction = 'desc';
            name = name.substr(1);
        }

        var sort = {
            direction: direction,
            name: name
        }

        return sort;
    }

    function setSortOrder(name) {
        var obj = getSortName(name);
        var newClass = 'sorting_' + obj.direction;

        $('.sorting_desc').removeClass().addClass('sorting');
        $('.sorting_asc').removeClass().addClass('sorting');
        $('[data-name="' + obj.name + '"]').removeClass().addClass(newClass);
    }

    function deparamQueryParams() {
        var hash = window.location.hash;
        if (hash) {
            return $.deparam(hash.replace(/\/?#/, ""));
        }
    }

    function resetParams(table) {
        window.location.hash = '';
        $('#js-filter-form input[type="text"]').val('');
        $('#js-filter-form input[type="checkbox"]').attr('checked', false);
        $('.selectpicker').val('').selectpicker('refresh');
        $('.dataTables_filter input[type="text"]').val('');
        table.search( '' ).columns().search( '' );
        table.ajax.reload();
    }

    function mapParams(data) {
        var col = data.order[0].column;
        var direction = data.order[0].dir;
        var options = {
            col: sortCols[col],
            direction: data.order[0].dir
        };

        if (direction === 'desc') {
            options.col = '-' + sortCols[col];
        }

        return options;
    }

    function setParams(data, formElement) {
        data.page_size = 25;
        var advancedParams = advancedSearch("#js-filter-form");

        if (formElement) {
            advancedParams = advancedSearch(formElement);
        }

        $.each(advancedParams, function(key, value) {
            data[key] = value;
        });

        if (data.start) {
            data.page = (data.start / data.length);
        }

        if (data.order && data.order.length || data.search && data.search.value) {
            var options = mapParams(data);
            var col = options.col;
            data.sort = options.col;
        }

        return data;
    }

    function setHash(params, storageName) {
        if (storageName) {
            var storedHash = localStorage.getItem(storageName);
        }

        var hash = dataTableAjax.deparamQueryParams();

        if (storedHash) {
            var storedHashObj = $.deparam(storedHash.substring(1));
        }

        if (drawCount < 1 && window.location.hash) {
            $.extend(params, hash);
            drawCount++;
        } else if (drawCount < 1 && !window.location.hash && storedHashObj) {
            $.extend(params, storedHashObj);
            window.location.hash = storedHash;
            drawCount++;
        } else {
            $.extend({}, params, hash);
        }
    }

    function formatDate(date, includeTime) {
        if (date && date !== '0000-00-00 00:00:00' && includeTime !== false) {
            return moment(date).format('M/DD/YY, h:mm a');
        } else if (date && date !== '0000-00-00 00:00:00' && includeTime === false) {
            return moment(date).format('M/DD/YY');
        } else {
            return '--';
        }
    }
    
    function renderXss(data, type, full) {
        return xss(data);
    }

    return {
        sortCols: sortCols,
        setParams: setParams,
        resetParams: resetParams,
        renderTemplate: renderTemplate,
        deparamQueryParams: deparamQueryParams,
        setSortOrder: setSortOrder,
        setHash: setHash,
        formatDate: formatDate,
        renderXss: renderXss
    };
})();